export const setEECSvgImagePrefix = (svgImageUrlPrefix, eecComponentId, multipleEccCount) => {
    for (let i = 0; i < multipleEccCount; i++) {
        const energyLabel = document?.getElementById(i + "-" + eecComponentId);
        const elementWithEnergyIcon = energyLabel?.shadowRoot?.querySelector("div > svg > use");
        elementWithEnergyIcon?.setAttribute("href", svgImageUrlPrefix + elementWithEnergyIcon.getAttribute("href"));
    }
};
